import { render, staticRenderFns } from "./BulkImportModal.vue?vue&type=template&id=13436023&"
import script from "./BulkImportModal.vue?vue&type=script&lang=js&"
export * from "./BulkImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13436023')) {
      api.createRecord('13436023', component.options)
    } else {
      api.reload('13436023', component.options)
    }
    module.hot.accept("./BulkImportModal.vue?vue&type=template&id=13436023&", function () {
      api.rerender('13436023', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/modals/BulkImportModal.vue"
export default component.exports